import * as API from 'common/constant/routes'
import { getJson, deleteJson, postJson } from 'helper/http'

export const getSavedUrls = (userId) => getJson(API.GET_SAVED_URLS, {}, { userId })
export const saveNewUrl = (date, id, userId, title, url, description, hash) => postJson(API.SAVE_NEW_URL, {}, { date, id, userId, title, url: encodeURIComponent(url), description: (description && description.length > 0 ? description : '...') , hash: hash })
export const deleteSavedUrl = (id, userId) => deleteJson(API.DELETE_SAVED_URL, {}, { id, userId })
